import React from 'react';

const Hero = () => {
  return (
    <section className="relative pt-24 pb-32 overflow-hidden hero-gradient" id="hero">
      <div className="max-w-container-max mx-auto px-margin-desktop text-center">

        {/* Trust badge */}
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-surface-container-high executive-border mb-8">
          <span
            className="w-2 h-2 rounded-full bg-tertiary-fixed"
            style={{ boxShadow: '0 0 10px rgba(98,255,150,0.5)' }}
          ></span>
          <span className="text-label-caps font-label-caps text-on-surface-variant">TRUSTED BY 1,000+ SMBs</span>
        </div>

        {/* Main heading */}
        <h1
          className="font-display-lg text-display-lg text-primary max-w-4xl mx-auto mb-6 tracking-tight leading-[1.1]"
          data-testid="hero-title"
        >
          Management at the Speed of Voice
        </h1>

        {/* Subtitle */}
        <p className="font-body-lg text-body-lg text-on-surface-variant max-w-2xl mx-auto mb-10 leading-relaxed">
          Your Personal AI Assistant for Business Growth. Manage sales, stock, and customer khatas with voice commands.
        </p>

        {/* CTA buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a
            href="/signup"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:w-auto bg-primary text-on-primary px-10 py-4 rounded-xl font-headline-md font-bold hover:opacity-80 transition-all transform hover:scale-105 no-underline"
            data-testid="hero-cta-signup"
          >
            Start 14-Day Free Trial
          </a>
          <button
            className="w-full sm:w-auto executive-border bg-surface-container-lowest text-primary px-10 py-4 rounded-xl font-headline-md font-bold hover:bg-surface-container transition-all flex items-center justify-center gap-2"
            data-testid="hero-cta-demo"
          >
            <span className="material-symbols-outlined">play_circle</span>
            Watch Demo Video
          </button>
        </div>

        {/* Product preview */}
        <div className="mt-24 relative mx-auto max-w-5xl group">
          <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent z-10 pointer-events-none"></div>
          <div className="rounded-2xl executive-border overflow-hidden bg-surface-container-lowest p-2 shadow-2xl">
            <img
              alt="Consai Dashboard"
              className="w-full rounded-xl opacity-90 group-hover:opacity-100 transition-opacity"
              src="/dashboard-preview.png"
              data-testid="hero-dashboard-img"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
